import { apiPost } from './api'
import { NewClientData } from '../components/molecules/NewClientForm'

export const sendNewClientLead = async (data: NewClientData): Promise<void> => {
  await apiPost('/new-client', data)
}
